import { COUNTRY_CODE, COUNTRY_CODE_CURRENCIES, COUNTRY_CODE_LOCALES, TAX_PERCENTAGES } from "../constants/intl";

export const formatCurrency = (amount: number, countryCode: COUNTRY_CODE): string => {
  const currencyFormatter = new Intl.NumberFormat(COUNTRY_CODE_LOCALES[countryCode], {
    style: 'currency',
    currency: COUNTRY_CODE_CURRENCIES[countryCode]
  });
  return currencyFormatter.format(amount ?? 0);
}

export const formatNumber = (amount: number, countryCode: COUNTRY_CODE): string => {
  const numberFormatter = new Intl.NumberFormat(COUNTRY_CODE_LOCALES[countryCode]);
  return numberFormatter.format(amount);
}

export const formatPercentage = (amount: number, countryCode: COUNTRY_CODE): string => {
  const percentageFormatter = new Intl.NumberFormat(COUNTRY_CODE_LOCALES[countryCode], {
    style: 'percent',
    minimumFractionDigits: 0, // Adjust as needed
    maximumFractionDigits: 0, // Adjust as needed
  });
  return percentageFormatter.format(amount);
}

export const roundCurrency = (amount: number): number => Number(amount.toFixed(2));

export const calculatePostTaxAmount = (amount: number, countryCode: COUNTRY_CODE): number => {
  const multiplier = TAX_PERCENTAGES[countryCode] + 1;
  return roundCurrency(amount * multiplier);
}